var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24868 3.1697H4.50993C2.93965 3.1697 1.66669 4.44263 1.66669 6.01286V15.4901C1.66669 17.0604 2.93965 18.3333 4.50993 18.3333H13.9874C15.5577 18.3333 16.8307 17.0604 16.8307 15.4901L16.8307 10.7515M6.40543 13.5946L9.85365 12.8998C10.0367 12.863 10.2048 12.7728 10.3368 12.6407L18.056 4.9176C18.426 4.54731 18.4258 3.9471 18.0554 3.57712L16.4202 1.94383C16.0499 1.57401 15.45 1.57426 15.0801 1.94439L7.3601 9.66834C7.22835 9.80016 7.1384 9.96789 7.10148 10.1506L6.40543 13.5946Z",
    stroke: "#4F4D55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.f788dee3cd68d202e3bd786ca545e50c.svg";
export { ForwardRef as ReactComponent };